export const styles = theme => ({
  container: {
    maxHeight: 360,
    overflow: 'auto'
  },
  listHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.paper
  },
  disabled: { 
    opacity: 0.3,
    pointerEvents: 'none'
  }
})



// WEBPACK FOOTER //
// ./src/components/Sources/styles.js